import { CMSController, ContentController, ControllerHelper, FileEntrySearchResultDto, PALMSController, PostController, PostDownloadDto, ProjectGroupSearch, SearchResultsDto, WikiController } from "collaboration-service";
import { Button, Dimmer, getColor, Icon, LoaderInline, styled } from "imaginarity-react-ui";
import * as React from "react";
//import { useSelector } from "react-redux";
import { ApplicationState, useAppDispatch, useAppSelector } from "services/ApplicationState/ApplicationState";
import { useImgI18N } from "services/ImgI18N";
//import { shallowCompare } from "services/Helpers";
//import { useImgI18N } from "services/ImgI18N";
import { Updater } from "@tanstack/react-table";
import ArraySelection from "components/ArraySelection";
import LoadingDataTable, { ColumnDefintion, LoadingDataTableProps } from "components/LoadingDataTable/LoadingDataTable";
import * as _ from "lodash";
import { Actions } from "services/ApplicationState/Actions";
import { shallowCompare, useFadeColor, useLightenColor } from "services/Helpers";
import { nop } from "services/Helpers/EventHelper";
import { RenderFileEntryPreview } from "views/CMS/CMSSearch";
import { GlobalPostSearchFilterProps } from "./Filters/StandardFilter";
import {
    BATCH,
    getColumns,
    getFilterComponent,
    getInitFilter,
    getSearchMethod,
    getSuggestMethod,
    globalPostSearchReducer,
    GlobalPostSearchState,
    PostTypes, postTypesElements,
    set_CMS_MODE,
    set_FE_FILTER,
    set_FILTER,
    set_LOADING,
    set_POST_TYPE,
    set_RESULTS,
    set_SEARCH,
    set_SELECTED,
    set_TOKEN
} from "./GlobalPostSearchHelpers";
import GlobalPostSearchSearchField from "./GlobalPostSearchSearchField";

interface GlobalPostSearchProps {
    show?: boolean;
    onSelect?: (selected: Array<{ id: string, type: string, data: any }>) => void;
    onClose?: () => void;
    allowedTypes?: PostTypes[];
    preSelected?: string[];
    isMulti?: boolean;
    excludeCategories?: string[];
}

const C = styled.div`
    width: calc(100vw - 80px);
    max-width: 1840px;
    height: calc(100vh - 80px);
    overflow: hidden;
    //min-height:60vh;
    display: grid;
    grid-template-rows: 50px max-content 1fr;
    background-color: ${p => getColor(p, "@mainBackground")};
    /* margin: 40px; */
    margin: auto;
    padding: 40px;
    border: 1px solid ${p => getColor(p, "@lightGrey")};
    text-align: left;
    box-shadow: 0 6px 8px -6px #000;
`;
const FilterBar = styled.div`    
    background-color: ${p => getColor(p, "@veryLightGrey")};
    overflow-y: auto;
    height: ${window.innerHeight - 202}px;
    width: 320px;
    border: 1px solid ${p => getColor(p, "@middleLightGrey")};
    color: ${p => getColor(p, "@darkerGrey")};
`;
const TableContainer = styled.div`    
    width: calc(100% + 0px);
    padding-left: 0px;    
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 40px;
    border: 1px solid ${p => getColor(p, "@middleLightGrey")};
    position: relative;
    overflow: hidden;
    &>div:first-child {
        transform: translate(3px, -5px);
    }
`;
const TableContainerBottom = styled.div`  
    background: ${p => getColor(p, "@veryLightGrey")};
    display: grid;
    grid-template-columns: 1fr max-content max-content;
    column-gap: 10px;
    button>div{margin: 0;}
`;
const TableContainerBottomInfo = styled.div`  
    color: ${p => getColor(p, "@lightGrey")};
    line-height: 40px;
    font-size: 0.9em;
    float: left;
    padding-left: 10px;
`;

const IC = styled.div<{ withFilter: boolean }>`
    display: grid;
    grid-template-columns: ${p => p.withFilter ? "320px 1fr" : "0px 1fr"};   
    column-gap: 10px;
    height: ${window.innerHeight - 202}px;
`



type MemoStuff = {
    FilterComponent?: React.FC<GlobalPostSearchFilterProps>;
    searchMethod: typeof PostController.SearchPostText3 | typeof WikiController.Search1 | typeof CMSController.SearchFiles | typeof CMSController.SearchProjects | typeof PALMSController.CatalogSearch;
    suggestMethod?: typeof PostController.SuggestPostTerm2 | typeof WikiController.SuggestTerm | typeof CMSController.SuggestFiles | typeof CMSController.SuggestProjects;
    lng?: string;
    cols: ColumnDefintion<any>[];
    pt: PostTypes
};

const mapper = (s: ApplicationState) => ({
    contentLanguage: s.contentLanguage,
    locations: s.cmsState.locations,
    location: s.cmsState.location
});

const GlobalPostSearch = (p: GlobalPostSearchProps) => {
    const { onSelect, show, onClose, allowedTypes, preSelected, isMulti, excludeCategories } = p;
    const initialState: GlobalPostSearchState = {
        postType: allowedTypes?.[0] ?? "TubePost",
        search: undefined,
        filter: { onlyFittingAllCategories: true },
        feFilter: undefined,
        results: undefined,
        token: {},
        loading: false,
        selected: undefined,
        cmsMode: "Project",
    };
    const appDispatch = useAppDispatch();
    const [state, dispatch] = React.useReducer(globalPostSearchReducer, initialState);
    const lastSearchData = React.useRef<any | undefined>(undefined);
    const allowedTypesRef = React.useRef<PostTypes[]>();
    const modalRef = React.useRef<HTMLDivElement>(null);
    const [showCMSPreview, setShowCMSPreview] = React.useState<FileEntrySearchResultDto>();

    const { cmsMode, feFilter, filter, loading, postType, results, search, selected, token } = state;

    const { t, currentLanguage } = useImgI18N("general");
    const { contentLanguage, location, locations } = useAppSelector(mapper, shallowCompare);
    const curLng = contentLanguage ?? currentLanguage;

    React.useEffect(() => {
        const l = async () => {
            const locs = await ControllerHelper.singleCall({ grouptype: "CMS" }, ContentController.GetContentPostContentLocationForAllGroupsByGroupType, true)
            appDispatch(Actions.setCMSLocations(locs));

        };
        if (!locations)
            l();
    }, [locations, appDispatch])

    React.useEffect(() => {
        if (allowedTypesRef.current && _.isEqual(allowedTypesRef.current, allowedTypes))
            return;
        dispatch(set_POST_TYPE(allowedTypes?.[0] ?? "TubePost"));
        allowedTypesRef.current = allowedTypes;
    }, [allowedTypes]);

    React.useEffect(() => {
        if (cmsMode === "Project") {
            dispatch(set_FE_FILTER(undefined));
        }
    }, [cmsMode]);

    const [initPageSize, setInitPageSize] = React.useState<number>(10);
    React.useEffect(() => {
        const handleResize = () => {
            const newItemsToShow = Math.floor((window.innerHeight - 340) / 40) - 1;
            setInitPageSize(newItemsToShow);
        };
        handleResize(); // Initial call to set the itemsToShow
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [initPageSize]);


    const { searchMethod, suggestMethod, FilterComponent, lng, cols, pt } = React.useMemo(() => {
        const searchMethod = getSearchMethod(postType, cmsMode);
        const suggestMethod = getSuggestMethod(postType, cmsMode);
        const toReturn: MemoStuff = {
            FilterComponent: getFilterComponent(postType),
            searchMethod,
            suggestMethod,
            lng: postType === "WikiArticle" ? curLng : undefined,
            cols: getColumns(postType, cmsMode),
            pt: postType,
        };
        return toReturn;
    }, [postType, curLng, cmsMode]);

    const ptChg = React.useMemo(() => (val: string) => {
        dispatch(BATCH([
            set_POST_TYPE(val as PostTypes),
            set_RESULTS(undefined),
            set_SEARCH(undefined),
            set_FE_FILTER(undefined),
            set_FILTER(getInitFilter(val as PostTypes, excludeCategories))
        ]))
    }, [excludeCategories]);

    React.useEffect(() => {
        ptChg(postType);
        // eslint-disable-next-line 
    }, []);

    const loadMore = React.useMemo(() => {
        if (!show)
            return nop;
        const searchData = {
            filter: filter,
            feFilter: feFilter,
            text: search ?? (pt === "FileEntry" ? "*" : ""),
            admin: false,
            byFileName: false,
            ordered: true,
            loadingCount: initPageSize
        } as any;

        const save = (res: SearchResultsDto<any>) => {
            //            console.log("GeneralPostSearch.tsx::400 => res", res);
            if (pt === "FileEntry") {
                const loadData = async () => {
                    if (cmsMode === "Project") {
                        const tasks = _.map(res.results, r => ControllerHelper.singleCall({ toFill: r as ProjectGroupSearch }, CMSController.FillProjectSearchResult));
                        const filled = await Promise.all(tasks);
                        dispatch(set_RESULTS({ ...res, results: filled }));
                    } else {
                        const tasks = _.map(res.results, r => ControllerHelper.singleCall({ toFill: r as FileEntrySearchResultDto }, CMSController.FillFileSearchResult));
                        const filled = await Promise.all(tasks);
                        dispatch(set_RESULTS({ ...res, results: filled }));
                    }
                }
                loadData();
            }

            dispatch(BATCH([
                set_RESULTS(res),
                set_TOKEN({ forward: res.forwardToken, backward: res.backwardToken }),
                set_LOADING(false),
            ]));
            lastSearchData.current = searchData;
        }

        if (lng) {
            if (!_.isEqual(lastSearchData.current, searchData)) {
                dispatch(set_LOADING(true));
                searchMethod({ ...searchData, lng }, save);
            }
            return (token: string) => {
                dispatch(set_LOADING(true));
                searchMethod({ ...searchData, lng, token: { token }, continuationTokenInput: { token } }, save);
            }
        }
        else {
            if (!_.isEqual(lastSearchData.current, searchData)) {
                dispatch(set_LOADING(true));
                searchMethod(searchData, save);
            }
            return (token: string) => {
                dispatch(set_LOADING(true));
                searchMethod({ ...searchData, token: { token }, continuationTokenInput: { token } }, save);
            }
        }
    }, [filter, searchMethod, search, lng, pt, cmsMode, show, feFilter, initPageSize]);

    // const { prev, next } = React.useMemo(() => {
    //     return ({
    //         next: () => {
    //             if (token.forward) {
    //                 loadMore(token.forward);
    //             }
    //         },
    //         prev: () => {
    //             if (token.backward) {
    //                 loadMore(token.backward);
    //             }
    //         }
    //     })
    // }, [token, loadMore]);

    const data = React.useMemo(() => {
        const res = (results?.results ?? []);
        //const res = [...x, ...x, ...x, ...x, ...x, ...x, ...x, ...x, ...x, ...x];
        return [...res, ..._.times(initPageSize - res.length, () => ({ id: "", createdAt: new Date(), headlines: [], group_id: "" }))];
    }, [results, initPageSize]);

    const onSel = React.useMemo(() => (row: PostDownloadDto) => {
        if (pt === "FileEntry" && cmsMode === "Project") {
            dispatch(BATCH([
                set_CMS_MODE("File"),
                set_FILTER({ onlyInProjectGroups: [row.id], excludeCategories: excludeCategories }),
                set_SEARCH("*"),
            ]));
            return;
        }
        if (onSelect) {
            onSelect([{ id: row.id, type: pt, data: row }]);
        }
    }, [onSelect, pt, cmsMode, excludeCategories]);

    const markColor = useFadeColor("@accentBlue", 10);
    const markTextColor = useLightenColor("@accentBlue", 95);

    const mark = React.useMemo(() => (id: string) => {
        return _.includes(preSelected, id) ? { backgroundColor: markColor, fontWeight: 500, color: markTextColor } : undefined;
    }, [preSelected, markColor, markTextColor]);


    const useSel = React.useMemo(() => () => {
        onSelect?.(_.map(selected, s => ({ id: s.id, type: pt, data: s })))
    }, [onSelect, selected, pt]);

    const disabled = !selected || selected.length === 0;

    const pagingHandler: LoadingDataTableProps<any, any, any>["ownPaging"] = {
        getPageCount: () => Math.floor(((results?.totalCount ?? 0) / initPageSize) + 1),
        getCanNextPage: () => !!token.forward,
        getCanPrevPage: () => !!token.backward,
        getPageIndex: () => (results?.pageIndex ?? 1) - 1,
        setPageIndex: async (index: Updater<number>) => {
            //console.log(index);
            if (index !== (results?.pageIndex ?? 1) - 1) {
                //console.log("for new index => ", index);
                const token = (results?.pageTokenTemplate ?? "")
                // eslint-disable-next-line
                const res = eval(`(index) => \`${token}\``)(index).trim("'");
                //console.log(`res = [${res}] [${token}]`);
                loadMore(res);
            }
        },
    };
    return (
        <>
            {showCMSPreview &&
                <Dimmer
                    active
                    onClick={() => setShowCMSPreview(undefined)}
                    button
                >
                    <>
                        <RenderFileEntryPreview
                            data={showCMSPreview}
                            lng={curLng}
                            location={location}
                        />
                    </>
                </Dimmer>

            }
            <Dimmer active={show} light strong blurred zIndex={10000} >
                <div className="didel" />
                <C ref={modalRef}>
                    <div style={{ display: "grid", gridTemplateColumns: "320px 320px 1fr max-content max-content", gap: 10 }}>
                        <div style={{ lineHeight: "40px", padding: "0 7px", fontSize: "1.2em", fontWeight: "bolder" }}>
                            <Icon name="search" style={{ float: "left", marginRight: 10 }} size={24} marginTop={5} />
                            Search Content
                        </div>
                        {loading ?
                            <div style={{ gridColumnStart: 2, gridColumnEnd: 4 }}>
                                <LoaderInline active infoText="loading data" />
                            </div>

                            :
                            <>
                                {suggestMethod ?
                                    <GlobalPostSearchSearchField
                                        filter={filter}
                                        onSearch={(val) => dispatch({ type: "SET_SEARCH", search: val })}
                                        suggestMethod={suggestMethod}
                                        lng={lng}
                                        feFilter={feFilter}
                                    />
                                    : <div />
                                }
                                <div style={{ maxWidth: "320px" }}>
                                    <ArraySelection
                                        array={allowedTypes ?? postTypesElements}
                                        isMulti={false}
                                        namespace='playlist'
                                        onChange={ptChg}
                                        value={postType}
                                    />
                                </div>
                            </>
                        }
                        <div>
                            <Button content="Close" onClick={onClose} kind={disabled ? "secondary" : "halfTransparentButton"} icon="times" />
                        </div>
                        <div>
                            <Button
                                content="Use"
                                icon="check"
                                kind="primary"
                                onClick={useSel}
                                disabled={disabled} />
                        </div>
                    </div>
                    <div />
                    <IC withFilter={!!FilterComponent}>
                        {FilterComponent ?
                            <FilterBar ref={modalRef}>
                                <FilterComponent
                                    facets={results?.facets}
                                    containerRef={modalRef}
                                    filter={filter}
                                    onChange={(f) => { console.log("Filter changed", f); dispatch({ type: "SET_FILTER", filter: f }); }}
                                    feFilter={feFilter}
                                    onChangeFE={(f) => { console.log("FileEntry Filter changed", f); dispatch(set_FE_FILTER(f)); }}
                                    cmsMode={cmsMode}
                                    onChangeMode={(m) => {
                                        console.log("CMS Mode changed", m);
                                        dispatch(BATCH([
                                            set_CMS_MODE("Project"),
                                            set_FILTER(excludeCategories ? { excludeCategories: excludeCategories } : {}),
                                            set_SEARCH("*"),
                                            set_RESULTS(undefined),
                                        ]))
                                    }
                                    }
                                />
                            </FilterBar>
                            : <div />}
                        {results && results.results && results.results.length > 0 ?
                            <TableContainer>
                                <div>
                                    <LoadingDataTable
                                        namespace="general_post_search"
                                        columns={cols as any}
                                        loadData={data}
                                        loaderData={{}}
                                        initPageSize={initPageSize}
                                        onSelectionChanged={(sel) => dispatch(set_SELECTED(sel))}
                                        onDoubleClick={onSel}
                                        mark={mark}
                                        hideMoreLessEnties={false}
                                        multiSelect={isMulti}
                                        ownPaging={pagingHandler}
                                        noBottomPadding={true}
                                        isLoading={loading}
                                        meta={setShowCMSPreview}
                                    />
                                </div>
                                <TableContainerBottom>
                                    <div>
                                        {/* <Button floated="left" icon="chevron left" onClick={prev} disabled={!token.backward} kind="cancelButton" tooltip={!token.backward ? undefined : { tooltipText: t("previous"), position: "top", zIndex: 5000000000 }} />
                                    <Button floated="left" icon="chevron right" onClick={next} disabled={!token.forward} kind="cancelButton" tooltip={!token.forward ? undefined : { tooltipText: t("next"), position: "top", zIndex: 5000000000 }} /> */}
                                        <TableContainerBottomInfo>
                                            {t("page {{idx}} of {{pages}} with {{total}} results in total", { idx: (results?.pageIndex ?? 1), pages: Math.floor(((results?.totalCount ?? 0) / initPageSize) + 1), total: results?.totalCount ?? 0 })}
                                        </TableContainerBottomInfo>
                                    </div>
                                    <div>
                                        <Button content="Close" onClick={onClose} kind={disabled ? "secondary" : "halfTransparentButton"} icon="times" />
                                    </div>
                                    <div>
                                        <Button
                                            content="Use"
                                            icon="check"
                                            kind="primary"
                                            onClick={useSel}
                                            disabled={disabled}
                                        />
                                    </div>
                                </TableContainerBottom>

                            </TableContainer>
                            :
                            <div />
                        }
                    </IC>
                </C>
            </Dimmer>
        </>
    )
}

export default GlobalPostSearch;
